

let state = {
    env: {
        platform: "h5" // h5/wx/mp   默认h5
    },
    channelType: "M",//通道类型
    // 企业信息相关
    eNo: "132908655287",
    enterprise: {},

    // 数码信息相关
    codeBase: {},
    code: "",

    // 解码状态
    decodestatus: null,
    errCodeList: [
        // 这些错误状态直接跳到错误页
        "200101",
        "200102",
        "200201",
        "200202",
        "200203",
        "200204",
        "200205",
        "200206",
        "300101"
        // "300102"
    ],

    // 地理位置相关
    gis: null, // 地理位置相关
    needGis: false, // 当前是否需要获取地理位置信息
    gpsType: 1,//GPS获取方式：1精准定位，2模糊定位，3不定位,4:IP定位
    childData: {},
    // 多语言相关
    lang: "en-US", // 语言类型
    loadedLangPackages: {}, // 已经加载的语言包
};



export default state
